import { useState, useEffect } from 'react';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from '../utils/firebase';

/**
 * Custom hook to fetch brewery count trends for the last 28 entries
 * @returns {Object} Object containing trend data, loading state, and error
 */
function useBreweryTrend() {
  const [trendData, setTrendData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTrendData = async () => {
      try {
        setLoading(true);
        setError(null);

        // Query to get the last 28 systemStats records (daily entries)
        const statsRef = collection(db, 'systemStats');
        const statsQuery = query(statsRef, orderBy('date', 'desc'), limit(28));

        const querySnapshot = await getDocs(statsQuery);

        if (!querySnapshot.empty) {
          const data = querySnapshot.docs.map((doc) => {
            const docData = doc.data();
            return {
              date: docData.date?.toDate?.() || new Date(docData.date),
              breweriesCount: docData.metrics?.breweriesCount || 0,
              openBreweriesCount: docData.metrics?.openBreweriesCount || 0,
            };
          });
          // Reverse to get chronological order for sparkline
          setTrendData(data.reverse());
        } else {
          setTrendData([]);
        }
      } catch (err) {
        console.error('Error fetching brewery trend data:', err);
        setError(err.message);
        setTrendData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTrendData();
  }, []);

  return { trendData, loading, error };
}

export default useBreweryTrend;
